import { CircleAlert, CircleCheck, Info, TriangleAlert, type LucideIcon } from 'lucide-react';

export type Tone = 'info' | 'success' | 'warning' | 'danger';

// Alert and Toast: each tone's icon, so colour is never the only signal, and its role tokens (text on the role's
// tint, design system §3.1).
export const tones: Record<Tone, { icon: LucideIcon; className: string }> = {
  info: { icon: Info, className: 'border-info bg-info-muted text-info' },
  success: { icon: CircleCheck, className: 'border-success bg-success-muted text-success' },
  warning: { icon: TriangleAlert, className: 'border-warning bg-warning-muted text-warning' },
  danger: { icon: CircleAlert, className: 'border-danger bg-danger-muted text-danger' },
};
